import styled, { css } from "styled-components";

export const visuallyHiddenCss = css`
  border: 0;
  clip: rect(1px, 1px, 1px, 1px); /* for Internet Explorer */
  clip: rect(1px 1px 1px 1px);
  height: 1px;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const VisuallyHidden = styled.span`
  ${visuallyHiddenCss}
`;
